import React from 'react';
import s from '../../PromoBadge.scss';
const HexagonLocked32 = ({ className  })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        width: "32",
        height: "32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        opacity: "0.1",
        d: "M15 .577a2 2 0 0 1 2 0l11.856 6.846a2 2 0 0 1 1 1.732v13.69a2 2 0 0 1-1 1.732L17 31.423a2 2 0 0 1-2 0L3.144 24.577a2 2 0 0 1-1-1.732V9.155a2 2 0 0 1 1-1.732L15 .577Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: "0.1",
        d: "M15 3.577a2 2 0 0 1 2 0l9.258 5.346a2 2 0 0 1 1 1.732v10.69a2 2 0 0 1-1 1.732L17 28.423a2 2 0 0 1-2 0l-9.258-5.346a2 2 0 0 1-1-1.732v-10.69a2 2 0 0 1 1-1.732L15 3.577Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 6.577a2 2 0 0 0-2 0l-6.66 3.845a2 2 0 0 0-1 1.732v7.69a2 2 0 0 0 1 1.733L15 25.422a2 2 0 0 0 2 0l3.8-2.194v-2.19a.36.36 0 0 1 .15-.281.59.59 0 0 1 .36-.117h1.19v-2.263c.002-1.054.54-2.065 1.496-2.811.207-.161.429-.307.664-.437v-2.975a2 2 0 0 0-1-1.732L17 6.577Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M27.6 16a3.245 3.245 0 0 0-2.332 1.003 3.488 3.488 0 0 0-.968 2.417v2.366h-.77a.324.324 0 0 0-.233.1.348.348 0 0 0-.097.242v6.33a.352.352 0 0 0 .097.242.33.33 0 0 0 .233.1h8.14a.32.32 0 0 0 .233-.1.345.345 0 0 0 .097-.242v-6.33a.353.353 0 0 0-.097-.242.328.328 0 0 0-.233-.1h-.77V19.42a3.488 3.488 0 0 0-.968-2.417A3.245 3.245 0 0 0 27.6 16Zm.549 9.344v1.482a.58.58 0 0 1-.16.402.54.54 0 0 1-.777 0 .58.58 0 0 1-.16-.402v-1.482a1.14 1.14 0 0 1-.477-.555 1.192 1.192 0 0 1-.05-.74c.063-.247.202-.464.397-.62a1.086 1.086 0 0 1 1.356 0c.195.156.334.373.397.62a1.19 1.19 0 0 1-.05.74 1.14 1.14 0 0 1-.476.555Zm-2.476-3.558V19.42c0-.263.049-.524.145-.766.097-.243.238-.464.417-.65.18-.186.392-.334.626-.435a1.869 1.869 0 0 1 1.478 0c.234.101.447.249.626.435s.32.407.417.65c.096.242.146.503.145.766v2.366h-3.854Z",
        className: s['fill-color']
    }));
HexagonLocked32.displayName = 'HexagonLocked32';
export default HexagonLocked32;
